import React from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Outlet } from 'react-router-dom'
import GlobalLoader from '../components/GlobalLoader'

export default React.memo(function ProtectedRoute() {
  const Component = withAuthenticationRequired(Outlet, {
    onRedirecting: () => <GlobalLoader />,
  })

  return <Component />
})
